import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  BringzzPageContainer,
  BringzzIcon,
  BringzzText,
  BringzzInput,
  BringzzButton,
  BringzzBottomDrawer,
  BringzzRadioList,
  BringzzRadio,
} from "@bringzz/components";
import useRequest from "hooks/useRequest";
import { useNavigation } from 'context/NavigationContext';

const state = {
  checked: <div></div>,
  unChecked: <div></div>,
};

const RegisterEmployee = () => {
  const location = useLocation();
  const { navigate } = useNavigation();
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [pickerDrawerOpened, setPickerDrawerOpened] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const { sendRequest, loading } = useRequest();

  const params = new URLSearchParams(location.search);
  const belongs_to = params.get("employeeId");
  const firstName = params.get("firstName");
  const lastName = params.get("lastName");

  const handleRegister = async () => {
    const data = {
      belongs_to: belongs_to,
      password,
    };
    if (profileImage) {
      data.base64Image = profileImage;
    }
    const response = await sendRequest({
      method: "POST",
      url: "/module/user/registerPharmacyMember",
      data,
    });

    if (response.status === 'success') {
      navigate(`/register/employee/verifytoken?employeeId=${belongs_to}&firstName=${firstName}&lastName=${lastName}`);
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setProfileImage(reader.result);
    };
    if (file) reader.readAsDataURL(file);
  };

  return (
    <BringzzPageContainer
      className="bg-white"
      header={{ title: "Join Us" }}
      footer={
        <div className="pb-8 px-6">
          <BringzzButton
            size="lg"
            className="bg-magic-lilac w-full flex justify-center text-midnight-blue"
            disabled={!password || loading}
            onClick={handleRegister}
          >
            Continue
          </BringzzButton>
        </div>
      }
      authenticated={false}
    >
      <div className='flex justify-center h-full w-full'>
        <div className='relative bg-white w-full bg-cover bg-center py-8 px-4 flex flex-col'>
          <div className='z-10 flex flex-col '>
            <div className="flex justify-center items-center">
              <div className="text-center">
                <BringzzText
                  tag="h1"
                  style={{
                    fontSize: "26px",
                    margin: "0",
                  }}
                >
                  Welcome to Bringzz,
                  <br />
                  {firstName} {lastName}!
                </BringzzText>
              </div>
            </div>
            <div className="flex justify-center ">
              <BringzzText
                tag="p"
                style={{
                  fontSize: "16px",
                  color: "#6c757d",
                  marginTop: "10px",
                  lineHeight: "1.6",
                }}
              >
                We’re thrilled to have you here. Complete the steps below to set up
                your account.
              </BringzzText>
            </div>
            <div className="relative flex justify-center bg-magic-lilac/20">
              <div className="relative bg-white w-full bg-cover bg-center flex flex-col">
                <div className="flex-grow flex flex-col py-8 px-4">
                  <div className="z-10 flex flex-col">
                    <div className="space-y-6 mt-12 flex justify-center">
                      <div className="space-y-4 relative">
                        {profileImage ? (
                          <img
                            src={profileImage}
                            alt="Profile"
                            className="rounded-full border-4 border-magic-lilac h-32 w-32 object-contain"
                          />
                        ) : (
                          <div className="flex justify-center border-4 border-magic-lilac text-white font-bold text-3xl items-center rounded-full bg-midnight-blue h-32 w-32">
                            P
                          </div>
                        )}
                        <div
                          className="bg-magic-lilac h-8 w-8 absolute bottom-0 rounded-full right-2"
                          onClick={() => setPickerDrawerOpened(true)}
                        >
                          <BringzzIcon
                            size="14"
                            icon="IconPlus"
                            folder="LineIcons"
                            className="cursor-pointer flex h-full flex-col items-center justify-center"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center items-center">
                      <div className="pl-2 flex flex-col space-y-6 md:max-w-lg lg:max-w-xl xl:max-w-2xl">
                        <BringzzText tag="h3" className="text-midnight-blue">
                          <div className="flex flex-col">
                            <div>update Profile photo</div>
                            <div className="text-sm text-gray-500">(optional)</div>
                          </div>
                        </BringzzText>
                      </div>
                    </div>
                  </div>
                </div>
                <BringzzBottomDrawer
                  isOpen={pickerDrawerOpened}
                  title="Upload your Profile Picture"
                  close={() => setPickerDrawerOpened(false)}
                >
                  <div className="px-4 py-6">
                    <BringzzRadioList
                      state={state}
                      className="rounded-xl w-full text-center"
                      onChange={() => setPickerDrawerOpened(false)}
                    >
                      {["Camera", "Photos", "File"].map((option) => (
                        <BringzzRadio
                          key={option}
                          value={option}
                          className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400"
                          onClick={() => {
                            setPickerDrawerOpened(false);
                            document.getElementById("fileInput").click();
                          }}
                        >
                          <BringzzText tag="h3">{option}</BringzzText>
                        </BringzzRadio>
                      ))}
                    </BringzzRadioList>
                    <input
                      type="file"
                      id="fileInput"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileSelect}
                    />
                  </div>
                </BringzzBottomDrawer>
              </div>
            </div>
            <div className='mt-6'>
              <BringzzInput
                icon={{
                  right: (
                    <BringzzIcon
                      icon={show ? "IconEye" : "IconEyeSlash"}
                      folder="LineIcons"
                      className="cursor-pointer"
                      size="16"
                      onClick={() => setShow(!show)}
                    />
                  ),
                }}
                type={show ? "text" : "password"}
                label="Password"
                pattern="^.{9,}$"
                onChange={(e, isValid, newValue) => setPassword(newValue)}
              />
            </div>
            <div className="mt-6">
              <BringzzText
                tag="p"
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  color: "#6c757d",
                  marginBottom: "20px",
                }}
              >
                By registering, I agree to the{" "}
                <a
                  href="/terms"
                  style={{ color: "#007BFF", textDecoration: "underline" }}
                >
                  User Agreement
                </a>{" "}
                and{" "}
                <a
                  href="/privacy"
                  style={{ color: "#007BFF", textDecoration: "underline" }}
                >
                  Privacy Policy
                </a>
                .
              </BringzzText>
            </div>
          </div>
        </div>
      </div>
    </BringzzPageContainer>
  );
};

export default RegisterEmployee;